// @flow
import type { CustomerActionType } from '../../Customer/actions';
import type { StateType } from '../../reducers';
import type { SignUpIdentificationActionType } from './actions';

export const initialState: IdentificationsStateType = {
  document: null,
  selfie: null,
};

export default (
  state: IdentificationsStateType = initialState,
  action: CustomerActionType | SignUpIdentificationActionType
) => {
  switch (action.type) {
    case 'SIGNUP_SET_PERSONAL_INFO':
    case 'SIGNUP_STORE_PASSPORT_INFO':
      return {
        ...state,
        document: action.payload.identification,
      };
    case 'SIGNUP_SET_SELFIE_IDENTIFICATION':
      const selfieIdentification = {
        ...action.payload.identification,
        identificationId: 'SELFIE',
        identificationType: 'SELFIE',
      };
      return {
        ...state,
        selfie: selfieIdentification,
      };
    default:
      return state;
  }
};

const identificationsStateSelector = (state: StateType): IdentificationsStateType => state.signUp.identifications;
export const identificationDocumentSelector = (state: StateType): ?Identification =>
  identificationsStateSelector(state).document;

export const signUpIdentificationsSelector = (state: StateType): Identification[] => {
  const identifications: IdentificationsStateType = identificationsStateSelector(state);
  // $FlowFixMe Array<mixed> issue : https://github.com/facebook/flow/issues/2221
  return Object.values(identifications).filter(Boolean);
};

export const hasIdDocumentSelector = (state: StateType): boolean => !!identificationsStateSelector(state).document;

export type IdentificationsStateType = {|
  document: ?Identification,
  selfie: ?Identification,
|};

export type Identification = {
  identificationId?: string,
  contentMediaType: 'image/jpg' | null,
  contentBase64?: string,
  identificationType:
    | 'PASSPORT'
    | 'IDENTITY_CARD'
    | 'DRIVER_LICENCE'
    | 'SOCIAL_SECURITY_NUMBER'
    | 'BIRTH_CERTIFICATE'
    | 'SELFIE'
    | 'PICTURE_ID',
};
